export enum InvestorNames {
  BankUnited = "BankUnited",
  Bayview = "Bayview",
  Caliber = "Caliber",
  Chase = "Chase",
  Eave = "Eave",
  Flagstar = "Flagstar",
  FranklinAmerican = "Franklin American",
  Lakeview = "Lakeview",
  MandatoryPipeline = "Mandatory Pipeline",
  MaxEx = "MaxEx",
  NexBank = "NexBank",
  PennyMac = "PennyMac",
  PHHMortgage = "PHH Mortgage",
  USBank = "US Bank",
}

export enum MaxExSubInvestorName {
  MaxExSubInvestorArchMortgage = "Arch Mortgage Funding, Inc.",
  MaxExSubInvestorBankOfAmerica = "Bank of America, National Association",
  MaxExSubInvestorCiti = "Citi",
  MaxExSubInvestorGoldmanSachs = "Goldman Sachs",
  MaxExSubInvestorJPMorgan = "JP Morgan",
  MaxExSubInvestorMorganStanley = "Morgan Stanley",
  MaxExSubInvestorNorthpointe = "Northpointe Bank",
  MaxExSubInvestorOnslowBay = "Onslow Bay Financial LLC (ANNALY Capital)",
  MaxExSubInvestorPrincipal = "Principal Bank",
}

// A1 through A9
export type MaxExSubInvestorType = "A1" | "A2" | "A3" | "A4" | "A5" | "A6" | "A7" | "A8" | "A9";
export const MaxExSubInvestors: MaxExSubInvestorType[] = [
  "A1",
  "A2",
  "A3",
  "A4",
  "A5",
  "A6",
  "A7",
  "A8",
  "A9",
];

export const MaxExSubInvestorNameMap: { [key in MaxExSubInvestorType]: string } = {
  A1: MaxExSubInvestorName.MaxExSubInvestorJPMorgan,
  A2: MaxExSubInvestorName.MaxExSubInvestorMorganStanley,
  A3: MaxExSubInvestorName.MaxExSubInvestorPrincipal,
  A4: MaxExSubInvestorName.MaxExSubInvestorOnslowBay,
  A5: MaxExSubInvestorName.MaxExSubInvestorGoldmanSachs,
  A6: MaxExSubInvestorName.MaxExSubInvestorCiti,
  A7: MaxExSubInvestorName.MaxExSubInvestorNorthpointe,
  A8: MaxExSubInvestorName.MaxExSubInvestorArchMortgage,
  A9: MaxExSubInvestorName.MaxExSubInvestorBankOfAmerica,
};

export enum WarehouseLine {
  BankUnited = "BankUnited",
  Flagstar = "Flagstar",
  WesternAlliance = "Western Alliance",
}

export type InvestorDetail = {
  id: number;
  loan_application_id: number;
  investor_name: InvestorNames;
  warehouse_line: WarehouseLine;
  investor_loan_number: string;
  investor_program_description: null;

  // dates
  investor_purchase_date: string;
  investor_rate_lock_date: string;
  investor_rate_lock_expiration_date: string;
  loan_service_transfer_date: string;

  // revenue
  actual_gain: string;
  actual_revenue: string;
  expected_gain: string;
  expected_revenue: string;

  created_at: string;
  updated_at: string;
};
